module.exports = __webpack_public_path__ + "3c0a275eb3efdf8a161b86127a5ad62c.svg";